module.exports = __webpack_public_path__ + "img/freezone.69692c5.png";